import { render, staticRenderFns } from "./supplyService.vue?vue&type=template&id=64d0a438&scoped=true&"
import script from "./supplyService.vue?vue&type=script&lang=js&"
export * from "./supplyService.vue?vue&type=script&lang=js&"
import style0 from "./supplyService.vue?vue&type=style&index=0&id=64d0a438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0a438",
  null
  
)

export default component.exports